import { Directive } from '@angular/core';

@Directive({
  selector: '[appNotForViewOnly]'
})
export class NotForViewOnlyDirective {

  constructor() { }

}
